import { trpc } from "#/lib/trpc/client"
import { PhotoIdImage } from "@internal/telemedicine"
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query"
import { photoIdOnFileQueryKey } from "./usePhotoIdOnFile"

type UploadIdDocumentsVariables = { front: PhotoIdImage; back: PhotoIdImage }
type UploadIdDocumentsData = Awaited<ReturnType<typeof trpc.telemedicine.uploadIdDocuments.mutate>>

export function useUploadIdDocuments(): UseMutationResult<UploadIdDocumentsData, Error, UploadIdDocumentsVariables> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (images: UploadIdDocumentsVariables) => trpc.telemedicine.uploadIdDocuments.mutate(images),
    // A successful upload means a complete ID is on file — reconcile the cached status so returning to
    // the page (after the mutation's in-memory success state is gone) doesn't show the uploader again.
    onSuccess: () => {
      queryClient.setQueryData(photoIdOnFileQueryKey, { onFile: true })
    }
  })
}
